import React from 'react'
import AppHeader from '../../../components/Header/Header'
import AppLayout from '@conponents/../../src/components/layout'
import BannerSection from '../../../components/ui/BannerSection'
import BreadcrumbNav from '../../../components/ui/BreadcrumbNav';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Portal do Estudante' },
  { label: 'Preparatório Online' },
];

const index = () => {
  return (
    <div>
      <header id='header'>
    <AppHeader />
  </header>
   <BannerSection
      title="Curso Preparatório"
      subtitle="Curso Preparatório para o exame de acesso do ISP-Atlântida"
      description={`Você quer garantir o seu lugar no ISP-Atlântida? Então este curso é para você!
      Com uma abordagem prática, moderna e 100% online, o nosso preparatório foi feito para aumentar suas chances de sucesso no exame de acesso..`}
      backgroundImage={require('../../../assets/prepar_curs.jpg')}
      backgroundId="instituition-Banner"
  />
    <BreadcrumbNav items={caminho} />
<main className="px-4 px-md-5 py-4 bg-light text-dark">
  <div className="container">
    <div className="row flex-row-reverse">
      <div className="col-12 col-md-4 col-lg-3 col-xl-2 mb-4">
        {/* Espaço reservado para menu lateral, banner ou extras */}
      </div>
      <div className="col-12 col-md-8 col-lg-9 col-xl-10">
       <section className="bg-white p-4 p-md-5 shadow-sm rounded-4">
  <h2 className="fw-bold mb-3" style={{ color: '#00761F' }}>Curso Preparatório para Exame de Acesso</h2>
  <p className="fs-5 lh-lg">
    O <strong>Curso Preparatório do ISP-Atlântida </strong> é a melhor preparação para acesso ao ensino superior. 
    Com uma abordagem focada nas principais áreas de estudo, oferece suporte ideal para enfrentar o Exame de Acesso com confiança.
  </p>

  <div className="mt-4">
    <h3 className="text-success fw-semibold">Áreas Disponíveis</h3>
    <ul className="fs-5 mt-2 ps-3">
      <li>Saúde</li>
      <li>Gestão</li>
      <li>Ciências Sociais</li>
      <li>Engenharia</li>
    </ul>
  </div>

  <div className="mt-4">
    <h3 className="text-success fw-semibold">Período de Inscrição</h3>
    <p className="fs-5">De <strong>23 de Junho</strong> a <strong>16 de Julho</strong></p>
  </div>

  <div className="mt-4">
    <h3 className="text-success fw-semibold">Valor</h3>
    <p className="fs-5">Por apenas <strong>5.000 Kz</strong></p>
  </div>

  <div className="mt-4">
    <h3 className="text-success fw-semibold">Benefício Exclusivo</h3>
    <p className="fs-5">Desconto para aqueles que queiram ingressar no ISPA.</p>
  </div>

  <div className="mt-4">
    <h3 className="text-success fw-semibold">Locais</h3>
    <ul className="fs-5 mt-2 ps-3">
      <li><strong>Talatona:</strong> Estrada lar do patriota, rua 14</li>
    </ul>
  </div>

  <div className="alert alert-success rounded-3 mt-4">
    <strong>O sucesso no Exame de Acesso começa com uma boa preparação!</strong><br />
    Garanta já a sua vaga no curso preparatório e aumente suas chances de ingresso.
  </div>

  <div className="text-center mt-4">
    <a href="/portal-do-estudante/Candidatura-online" className="btn btn-primary btn-lg rounded-pill px-4 shadow-sm">
      📘 Inscreva-se Agora
    </a>
  </div>
</section>

      </div>
    </div>
  </div>
</main>

    <AppLayout />
    </div>
  )
}

export default index

